import type { FC } from 'react'
import Image, { type ImageProps } from 'next/image'
import { CldImage, type CldImageProps } from 'next-cloudinary'

type NextImageVariantProps = { provider?: 'next' } & ImageProps
type CloudinaryImageVariantProps = { provider: 'cloudinary' } & CldImageProps

export type UniversalImageProps = NextImageVariantProps | CloudinaryImageVariantProps

export type Transformations = 'big' | 'medium' | 'small'

export const TRANSFORMATIONS: Record<Transformations, string> = {
  big: 'packshot-big',
  medium: 'packshot-medium',
  small: 'packshot-small',
}

const UniversalImage: FC<UniversalImageProps> = (props) => {
  if ('provider' in props && props.provider === 'cloudinary') {
    const { provider, ...cldProps } = props as CloudinaryImageVariantProps
    return <CldImage {...cldProps} />
  }

  const { provider, ...nextProps } = props as NextImageVariantProps
  return <Image {...nextProps} />
}

export default UniversalImage
